import { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'

export default function useExtendStayBooking() {
  const { mostRecentBooking, customer } = useContext(BootstrapDataContext)
  const extendStayTrip = mostRecentBooking?.current

  return extendStayTrip
    ? {
        travelEndDateTime: extendStayTrip.travelEndDateTime,
        cityName: extendStayTrip.cityName,
        hotelID: extendStayTrip.hotelID,
        numRooms: extendStayTrip.numRooms,
        title: extendStayTrip.title,
        customerFirstName: customer.firstName
      }
    : null
}
